import * as React from 'react';
import {
    MediaLibraryPage,
    MEDIA_LIBRARY_TITLE,
} from '../../components/MediaLibraryPage/MediaLibraryPage';
import { AnalyticsController } from '../../layout/Analytics';
import { SEO } from '../../layout/SEO';
import { helixAnalytics } from '../../shared/analytics/HelixAnalytics';

export default function MediaLibraryPressKits() {
    React.useEffect(() => {
        AnalyticsController.pageView({
            pageType: `Media Assets`,
        });
        helixAnalytics.trackPageView(`Media Assets`, `Media Library`);
    }, []);

    return <MediaLibraryPage tabName="presskits" />;
}

export const Head = ({ location }) => (
    <SEO
        title={`${MEDIA_LIBRARY_TITLE} | Media Assets `}
        location={location.pathname}
        description="View and download Spectrum media assets here. All content downloaded from this site may be used for editorial purposes only."
    />
);
